import React, { useState, useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useSubheader } from "../../../../../_metronic/layout";
import { useParams, useHistory } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  ModalProgressBar,
  Input,
  CustomeSelect,
  Textarea,
} from "../../../../../_metronic/_partials/controls";
// import moment from "moment";
import { Formik, Form, Field } from "formik";
import SearchSelectInput from "../../../../components/SelectComponents/SearchSelectInput";
import * as UIHelpers from "../../../../components/UIHelpers";
import helperFunc from "../../../../../_metronic/_helpers/helperFunc";
import Upload from "../../../../components/upload/Upload";
import DropdownReactSelect from "../../../../components/DropdownReactSelect";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import * as actions from "./_redux/HowToJoinActions";
export const initialFilter = {
  sort: "asc", // asc||desc
  sortBy: "order",
  skip: UIHelpers.skip,
  limit: UIHelpers.limit,
  type: null,
  subType: null,
  dateRange: null, //{from: moment().toDate(), to: moment().toDate()}
};
// export const contentTypeArr = [
//   { _id: "image", name: "Image" },
//   { _id: "text", name: "Text" },
//   { _id: "description", name: "Description" },
// ];
export default function EditCmsGP(props) {
  const suhbeader = useSubheader();
  const { id } = useParams();
  //suhbeader.setTitle("How to Play");
  let history = useHistory();
  const dispatch = useDispatch();
  const [file, setFile] = useState(undefined);
  const [handleTitle, sethandleTitle] = useState();
  const [handelcontentType, sethandelcontentType] = useState();
  const [handelCountry, sethandelCountry] = useState();
  const [content, setContent] = useState([]);
  const [selectedSignup, setSelectedSignup] = useState(null);
  const [count, setCount] = useState(0);
  const [Signup, setSignup] = useState("");
  const [countrySelectedDropdownFilterData,setCountryListDropdownFilterData] = useState();
  const [countryDropdownFilterData, setCountryDropdownFilterData] = useState(null);
  const [companySelectedDropdownFilterData,setCompanySelectedDropdownFilterData,] = useState(null);
  const [gameList,setGameList,] = useState(null);
  const [selectgameList,setSelectGameList] = useState(null);
  const [frmInitialValues, setFrmInitialValues] = useState(
    {
      country: '',
      title: '',
      description: '',
      game: '',
      contentType: '',
      isActive: true
    }
  );
  const { currentState } = useSelector(
    (state) => ({ currentState: state.howToJoinGP }),
    shallowEqual
  );
  const { howToJoinDetails, countryDropdownList, gameDropdownList } = currentState;
  const onUpdateFileValue = (file) => {
    setFile(file.image);
  };
  const removeContent = (ind) => {
    let contentArr = [...content];
    contentArr.splice(ind, 1);
    setContent(contentArr);
    setCount(count + 1);
  };
  const contentTypeArr = [
    { value: "image", label: "Image" },
    { value: "video", label: "Video" },
    { value: "desc", label: "Text" },
  ];
  useEffect(() => {
    dispatch(actions.fetchCountryList());
    dispatch(actions.fetchGameList2());
  }, []);
  useEffect(() => {
    if (id !== undefined) {
      dispatch(actions.fetchSingle(id));
    }
  }, [id, dispatch]);
  
  useEffect(() => {
    if (countryDropdownList) {
      let temp = [];
      countryDropdownList.forEach((element, i) => {
        temp.push({
          _id: i + 1,
          label: element.name,
          value: element._id,
        });
      });
      setCountryDropdownFilterData(temp);
    }
  }, [countryDropdownList]);

  useEffect(() => {
    console.log("gamelist", gameDropdownList)
    if (gameDropdownList) {
      let temp = [];
      gameDropdownList.forEach((element, i) => {
        temp.push({
          _id: i + 1,
          label: element.name,
          value: element._id,
        });
      });
      console.log("temp:", temp);
      setGameList(temp);
    }
  }, [gameDropdownList]);

  useEffect(() => {
    console.log("howToJoinDetails", howToJoinDetails)
    let _title = id ? "Edit How to Join" : "How to Join";
    const item = howToJoinDetails.item
    let data = { ...item };
    if (countryDropdownFilterData?.length > 0) {
      let cdtata = countryDropdownFilterData.filter(cd => cd.value.includes(howToJoinDetails?.country?._id))
      setCountryListDropdownFilterData(cdtata)
    }
    if (gameList) {
      if(howToJoinDetails?.item?.game){
        let cdtata = gameList.filter(cd => cd?.value?.includes(howToJoinDetails?.item?.game))
        console.log("^^^^^^^^^^^^^^cdtata", cdtata)
        data.game = cdtata.value
        setSelectGameList(cdtata)
      }else if(howToJoinDetails?.game?._id){
        let cdtata = [{
          value:howToJoinDetails?.game?._id,
          label:howToJoinDetails?.game?.name,
        }]
        data.game = cdtata.value
        setSelectGameList(cdtata)
      }
      
    }
    if (item?.title) {
      data.title = item?.title
    }
    data.content = '';
    setFrmInitialValues(data);
    setContent(item && item.content);
    suhbeader.setTitle(_title);
  }, [howToJoinDetails, id, gameList]);

  const saveForm = (values) => {
    // console.log("values", values)
    // console.log("countrySelectedDropdownFilterData", countrySelectedDropdownFilterData)
    // console.log("selectgameList", selectgameList)
    if (countrySelectedDropdownFilterData?.value) {
      values.country = countrySelectedDropdownFilterData?.value
    } else if (countrySelectedDropdownFilterData.length > 0 && countrySelectedDropdownFilterData[0]?.value) {
      values.country = countrySelectedDropdownFilterData[0]?.value
    } else {
      NotificationManager.error('Please Select Country', 'Error');
      return;
    }
    if (selectgameList?.value) {
      values.game = selectgameList?.value
    } else if (selectgameList.length > 0 && selectgameList[0]?.value) {
      values.game = selectgameList[0]?.value
    } else {
      NotificationManager.error('Please Select Game', 'Error');
      return;
    }
    values.content = content;
    if (!id) {
      dispatch(actions.createItem(values)).then((sucess) => sucess ? backToList() : null);
    } else {
      dispatch(actions.updateItem(values)).then((sucess) => sucess ? backToList() : null);
    }
  };

  const [selectedContentType, setSelectedContentType] = useState(null); // Initialize the state for the selected content type
  // Event handler to handle the selected content type change
  const handleContentTypeChange = (selectedOption) => {
    setSelectedContentType(selectedOption); // Update the selected content type in state
  };

  const addContent = (values, setFieldValue) => {
    let item = {};
    if (selectedContentType.value === 'desc') {
      item.type = 'text';
    }
    if (selectedContentType.value === 'video') {
      item.type = 'video';
    }
    item.content = values.content;
    if (selectedContentType.value === 'image') {
      item.type = 'image';
      if (file) {
        item.content = `${process.env.REACT_APP_UPLOADED_FILE_URL}/${file.default}`;
      }
    }
    if (content) {
      var contentArry = [...content];
    } else {
      var contentArry = [];
    }

    contentArry.push(item)
    setContent(contentArry);
    setFile(undefined);
    setCount(count + 1);
    setFieldValue('content', '');
    setFieldValue('contentType', 'none');
  }


  const backToList = () => {
    history.push(`/cms/setting/GP`);
  };
  return (
    <>
      {/* {actionsLoading && <ModalProgressBar />} */}
      <NotificationContainer />
      <Formik
        enableReinitialize={true}
        initialValues={frmInitialValues}
        onSubmit={(values) => {
          saveForm(values);
        }}
      >
        {({ handleSubmit, values, setFieldValue }) => (

          <Form className="form form-label-right">
            <Card>
              <CardHeader title={"Basic Detail"}></CardHeader>
              <CardBody>
                <div className="form-group row">
                  {/* {helperFunc.isCountryVisible() && ( */}
                  <div className="col-lg-3">
                    <label>Select Country</label>
                    <DropdownReactSelect
                      name="country"
                      value={countrySelectedDropdownFilterData}
                      isMulti={false}
                      isClearable={true}
                      isSearchable={true}
                      closeMenuOnSelect={true}
                      options={countryDropdownFilterData}
                      onChange={setCountryListDropdownFilterData}
                    />
                  </div>
                 
                  <div className="col-lg-4">
                    <Field
                      name="title"
                      // value={frmInitialValues?.title}
                      component={Input}
                      type="title"
                      placeholder="Title"
                      label="title"
                      isRequired={true}
                    />
                  </div>
                  <div className="col-lg-3">
                    <label>Select Game</label>
                    <DropdownReactSelect
                      name="game"
                      value={selectgameList}
                      isMulti={false}
                      isClearable={true}
                      isSearchable={true}
                      closeMenuOnSelect={true}
                      options={gameList}
                      onChange={setSelectGameList}
                    />
                  </div>
                  <div className="col-md-2">
                    <label className="col-form-label">Is Active</label>
                    <div className="col-12 w-100 p-0">
                      <span className="switch switch-primary switch-icon">
                        <label>
                          <Field type="checkbox" name="isActive" />
                          <span></span>
                        </label>
                      </span>
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
            <Card>
              <CardHeader title={"Contents"}></CardHeader>
              <CardBody>
                <div className="d-flex w-100 p-0">
                  <div className="col-md-3">
                    <label>Select Content Type</label>
                    <DropdownReactSelect
                      placeholder="Content Type"
                      name="contentType"
                      value={selectedContentType}
                      isMulti={false}
                      isClearable={true}
                      isSearchable={true}
                      closeMenuOnSelect={true}
                      options={contentTypeArr}
                      onChange={handleContentTypeChange}
                    />
                  </div>
                  {selectedContentType && (
                    <div className="col-md-6">
                      {selectedContentType.value === "desc" && (
                        <Field
                          name="content"
                          component={Textarea}
                          placeholder="Description"
                          label="Description"
                          isRequired={true}
                        />
                      )}
                      {selectedContentType.value === "video" && (
                        <Field
                          name="content"
                          component={Input}
                          placeholder="Video"
                          label="Video"
                          isRequired={true}
                        />
                      )}
                      {selectedContentType.value === "image" && (
                        <Field
                          name="content"
                          component={Upload}
                          file={file}
                          label="Image"
                          isRequired={true}
                          onfileValueSet={onUpdateFileValue}
                        />
                      )}
                    </div>
                  )}
                  <div className="col-md-3 mt-7">
                    <button
                      type="button"
                      onClick={() => addContent(values, setFieldValue)}
                      className="btn btn-primary ml-2"
                    >
                      Add
                    </button>
                  </div>
                </div>
                <div className="react-bootstrap-table table-responsive col-md-12 mt-6">
                  <table className="table table table-head-custom table-vertical-center overflow-hidden table-bordered">
                    <thead>
                      <tr>
                        <td>Sr No.</td>
                        <td>Content Type</td>
                        <td>Content</td>
                        <td>Action</td>
                      </tr>
                    </thead>
                    <tbody>
                      {content &&
                        content.length > 0 &&
                        content.map((item, ind) => (
                          <tr key={`content${ind}`}>
                            <td>{ind + 1}</td>
                            <td>{item.type}</td>
                            <td>{item.content}</td>
                            <td>
                              <button
                                type="button"
                                className="btn btn-danger ml-2"
                                onClick={() => removeContent(ind)}
                              >
                                <i className="ki ki-minus"></i>
                              </button>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </CardBody>
            </Card>
            <div className="form-group justify-content-end row mx-0">
              <button
                type="button"
                onClick={backToList}
                className="btn btn-light"
              >
                <i className="fa fa-arrow-left"></i>Back
              </button>
              <button
                type="submit"
                className="btn btn-primary ml-2"
              >
                {id ? "Update" : "Save"}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
}
